"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CxHeader = void 0;
const core_1 = require("@mantine/core");
const React = __importStar(require("react"));
const CxLogo_1 = require("./CxLogo");
const useStyles = (0, core_1.createStyles)((theme) => ({
    header: {
        paddingTop: theme.spacing.sm,
        paddingBottom: theme.spacing.sm,
        //backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        //backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.white,
        //backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : "#e6e6e6",
        backgroundColor: theme.other.mainBackgroundColor
        //borderBottom: `1px solid ${
        //    theme.colorScheme === 'dark' ? 'transparent' : theme.colors.gray[2]
        //}`,
        //height: '60'
        //marginBottom: 120,
    },
    logo: {
        width: '3em',
        height: '3em',
        paddingLeft: theme.spacing.xs
    },
    company: {
        fontFamily: 'verdana',
        color: '#B70200',
        fontWeight: 'bold',
        fontSize: '1.5em',
        textTransform: 'lowercase'
    },
    product: {
        fontFamily: 'Poppins',
        color: '#4E4E4E',
        fontSize: '1.5em',
        fontWeight: 'lighter'
    },
}));
const defaultProps = {
    logoElement: React.createElement(CxLogo_1.CxLogo, null),
    companyName: 'ascentis',
    children: React.createElement(React.Fragment, null)
};
function CxHeader(inputProps) {
    const props = (0, core_1.useComponentDefaultProps)('CxHeader', defaultProps, inputProps);
    const { classes, cx } = useStyles();
    // @ts-ignore
    return (React.createElement(React.Fragment, null,
        React.createElement(core_1.Header, { height: { base: 68 }, p: "xs", className: classes.header, withBorder: false },
            React.createElement(core_1.Group, { position: "apart", sx: { height: '100%' } },
                React.createElement(core_1.Group, { position: "left", spacing: "xs", align: "flex-end" },
                    props.logoElement && React.cloneElement(props.logoElement, {
                        className: cx(props.logoElement?.props?.className, classes.logo),
                    }),
                    React.createElement(core_1.Group, { position: "left", spacing: 0, align: "flex-end" },
                        React.createElement(core_1.Title, { className: classes.company }, props.companyName),
                        React.createElement(core_1.Title, { className: classes.product }, props.productName))),
                React.createElement(core_1.Group, { position: 'right', spacing: "xs", align: "flex-end" }, props.children)))));
}
exports.CxHeader = CxHeader;
//# sourceMappingURL=CxHeader.js.map